/**
 * @generated SignedSource<<3536664e9d7614cefb245700ec40592c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountBillingInfoBaseFragment$data = {
  readonly id: string;
  readonly extraBillingInformation: string | null;
  readonly " $fragmentType": "accountBillingInfoBaseFragment";
};
export type accountBillingInfoBaseFragment$key = {
  readonly " $data"?: accountBillingInfoBaseFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountBillingInfoBaseFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountBillingInfoBaseFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extraBillingInformation",
      "storageKey": null
    }
  ],
  "type": "AccountBillingInfo",
  "abstractKey": null
};

(node as any).hash = "a2d5ac9a132464234e40eaaedb5a3b8a";

export default node;
